module.exports = __webpack_public_path__ + "static/img/mark8-D3kPTiRD.014ca63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/mark8-D3kPTiRD.png
// module id = c7x3
// module chunks = 16